export default __webpack_public_path__ + "static/8-d443b8e8232e99f35222c1571667c9aa.png";